
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useBonusLoginAds } from '@/modules/bonus/login/model/ads';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';

export default defineComponent({
    name: ROUTE_NAME_BONUS.LOGIN.ADS,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useBonusLoginAds();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
